import { PreviewCard } from '@aibees/elephant/components/backoffice/preview-card';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(PreviewCard)``;

export const Badge = styled(Box)`
  position: absolute;
  left: ${(p) => p.theme.spacing(6.5)};
  top: ${(p) => p.theme.spacing(8.5)};
  color: ${(p) => p.theme.palette.common.white};
  border-radius: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1)};
  font-size: ${(p) => p.theme.typography.caption.fontSize};
  transition: all 0.1s ease-in-out;
`;

export const Logo = styled('img')`
  width: ${(p) => p.theme.spacing(3.5)};
  margin: auto;
`;
